import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { GraphicsContext } from "../../contexts/GraphicsContext";
import TeamNames from "../TopBar/TeamNames";
import TeamNamesHyper from "../TopBar/TeamNamesHyper";
import Goal from "../TopBar/Goal";
import { UIContext } from "../../contexts/UIContext";
import { useLazyQuery } from "@apollo/client";
import gql from "graphql-tag";
import { APIContext } from "../../contexts/APIContext";
import ServerStatus from "../ServerStatus/ServerStatus";
import GameStream from "../Game/GameStream";
import RightSideBarStream from "../RightSideBar/RightSideBarStream";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import useLocalStorage from "../../Hooks/useLocalStorage";
const LINEUP_FIELDS = gql`
  fragment LINEUP_FIELDS on LineupObject {
    home {
      squad {
        _id
        shirt_number
        opta_shirt_number
        position
        season_stats
        player {
          _id
          first_name
          last_name
          first_name_upper
          last_name_upper
          nationality {
            _id
            opta_code
            opta_name
          }
        }
      }
      order
      yellow_card
      dbl_yellow_card
      red_card
      sub_order
      subbed
      captain
    }
    away {
      squad {
        _id
        shirt_number
        opta_shirt_number
        position
        season_stats
        player {
          _id
          first_name
          last_name
          first_name_upper
          last_name_upper
          nationality {
            _id
            opta_code
            opta_name
          }
        }
      }
      order
      yellow_card
      dbl_yellow_card
      red_card
      sub_order
      subbed
      captain
    }
  }
`;
const GAME_BY_ID = gql`
  ${LINEUP_FIELDS}
  query GameByID($id: String) {
    gameById(id: $id) {
      _id
      time
      description
      date
      home_team_kit
      away_team_kit
      stadium {
        sotic_name
      }
      competition {
        badge
        name
        number_of_periods
      }
      home_scorers
      away_scorers
      home_penalties
      away_penalties
      lineup {
        ...LINEUP_FIELDS
      }
      home_team {
        _id
        name
        short_name
        code
        variables
      }
      away_team {
        _id
        name
        short_name
        code
        variables
      }
      live_data
      home_player_stats
      away_player_stats
      scores_by_quarter
      season {
        _id
      }
    }
  }
`;

const GAME_SUBSCRIPTION = gql`
  ${LINEUP_FIELDS}
  subscription GameUpdated($id: String!) {
    gameUpdated(_id: $id) {
      _id
      home_team_kit
      away_team_kit
      lineup {
        ...LINEUP_FIELDS
      }
      live_data
      home_scorers
      away_scorers
      home_penalties
      away_penalties
      home_player_stats
      away_player_stats
      scores_by_quarter
    }
  }
`;

const Main = styled.div`
  display: flex;
  width: 100%;
  font-size: 0.7em;
`;
const Content = styled.div`
  display: flex;
  margin-left: 1em;
  margin-right: 1em;
  margin-top: 0.5em;
  box-sizing: border-box;
  flex: 1;
  flex-direction: column;
`;
const RightBar = styled.div`
  display: flex;
  width: 300px;
  box-shadow: -3px 1px 3px 0 rgb(0 0 0 / 42%);
`;

export default function Stream({ setSelectedPlayer, selectedPlayer }) {
  let { gameID } = useParams();
  const [game, setGame] = useState();
  const [homeCoach, setHomeCoach] = useState();
  const [awayCoach, setAwayCoach] = useState();
  const [getGame, { data, subscribeToMore }] = useLazyQuery(GAME_BY_ID);
  const [mode] = useLocalStorage("hyper-netball-gfx-mode", "viz");
  const { goal, setGoal } = useContext(UIContext);
  const {
    previewGraphic,
    animateGraphic,
    graphicInPreview,
    animateOffGraphic,
    updateGraphic,
    clearPVW,
  } = useContext(GraphicsContext);
  const { updateGame, getSquadPlayers } = useContext(APIContext);

  useEffect(() => {
    if (gameID) {
      getGame({ variables: { id: gameID } });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gameID]);

  useEffect(() => {
    let unsubscribe;
    if (subscribeToMore) {
      console.log("Subscribed");
      unsubscribe = subscribeToMore({
        document: GAME_SUBSCRIPTION,
        variables: { id: gameID },
        updateQuery: (prev, { subscriptionData }) => {
          if (!subscriptionData.data) return prev;

          const updatedGame = subscriptionData.data.gameUpdated;
          let newGame = {
            gameById: { ...prev.gameById, ...updatedGame },
          };

          updateGraphic("ScoreBug", {
            game: newGame,
          });
          return newGame;
        },
      });
    }
    return () => {
      console.log("Unsubscribed");
      unsubscribe && unsubscribe();
    };
  }, [subscribeToMore, gameID]);

  useEffect(() => {
    if (data) {
      setGame({ ...data.gameById });
      getSquadPlayers({
        teamId: data.gameById?.home_team?._id,
        seasonId: data.gameById?.season?._id,
      })
        .then((data) => {
          setHomeCoach(
            data?.find((d) => d.type === "coach") || { type: "coach" }
          );
        })
        .catch((err) => {});
      getSquadPlayers({
        teamId: data.gameById?.away_team?._id,
        seasonId: data.gameById?.season?._id,
      })
        .then((data) => {
          debugger;
          setAwayCoach(
            data?.find((d) => d.type === "coach") || { type: "coach" }
          );
        })
        .catch((err) => {});
    }
  }, [data]);

  if (!game) return <div>Loading</div>;
  return (
    game && (
      <Main>
        <Content>
          {mode === "viz" && !goal && (
            <TeamNames
              setSelectedPlayer={setSelectedPlayer}
              homeTeam={game.home_team}
              awayTeam={game.away_team}
              game={game}
              stream={true}
            />
          )}
          {mode === "hyper" && !goal && (
            <TeamNamesHyper
              setSelectedPlayer={setSelectedPlayer}
              homeTeam={game.home_team}
              awayTeam={game.away_team}
              game={game}
              stream={true}
            />
          )}
          {goal && (
            <Goal
              goal={goal}
              setGoal={setGoal}
              cancel={() => {
                updateGame({
                  id: game._id,
                  home_scorers: game.home_scorers.filter((g) => g.player),
                  away_scorers: game.away_scorers.filter((g) => g.player),
                });
                setGoal();
              }}
            />
          )}

          <GameStream
            setGoal={setGoal}
            goal={goal}
            game={game}
            setSelectedPlayer={setSelectedPlayer}
            selectedPlayer={selectedPlayer}
            homeCoach={homeCoach}
            awayCoach={awayCoach}
          />
          {mode === "sky" && <ServerStatus />}
        </Content>

        {/* <RightBar>
          <RightSideBarStream
            game={game}
            previewGraphic={previewGraphic}
            graphicInPreview={graphicInPreview}
            animateGraphic={animateGraphic}
            animateOffGraphic={animateOffGraphic}
            updateGraphic={updateGraphic}
            selectedPlayer={selectedPlayer}
            clearPreview={clearPVW}
          />
        </RightBar> */}
      </Main>
    )
  );
}
